import InstallApp from "./install/app/InstallApp";
import { bootstrapApp } from "./bootstrap";

bootstrapApp("PenumbraOS Install", <InstallApp />);
